import { call, put, takeEvery } from 'redux-saga/effects'
import {
  GET_SITESURVEYS,
  ADD_SITESURVEY,
  UPDATE_SITESURVEY,
  DELETE_SITESURVEY,
} from './actionTypes'
import {
  getSiteSurveysSuccess,
  getSiteSurveysFail,
  addSiteSurveySuccess,
  addSiteSurveyFail,
  updateSiteSurveySuccess,
  updateSiteSurveyFail,
  deleteSiteSurveySuccess,
  deleteSiteSurveyFail,
  setSiteSurveyFieldErrors,
  getSiteSurveys,
} from './actions'
import axiosInstance from 'pages/Utility/axiosInstance'
import toast from 'react-hot-toast'
import Cookies from 'js-cookie'

// API calls
const fetchSiteSurveysApi = (data) => axiosInstance.get('', { params: { sp: 'usp_GetSiteSurveyReport', SiteSurveyStatus: data?.status || null, scheduledFromDate: data?.startDate || null, scheduledToDate: data?.endDate || null, TeamID: data?.teamId || null, createdBy: data?.userId || null ,createdDate:data?.createdAt != 'NaN-NaN-NaN' ? data?.createdAt : null,solutionId: (data?.solutionId && data?.solutionId != "null" && data?.solutionId != "undefined") ? data?.solutionId: null,sabelUserId: (data?.sebelUserId &&  data?.sebelUserId !=="undefined" && data?.sebelUserId !== "null")  ? `${data?.sebelUserId}` : null }  })
const addSiteSurveyApi = (SiteSurvey) => axiosInstance.post('', SiteSurvey)
const updateSiteSurveyApi = (SiteSurvey) => axiosInstance.post('', SiteSurvey)
const deleteSiteSurveyApi = (id) => axiosInstance.post('', { sp: 'usp_DeleteSiteSurvey', SiteSurveyId: id })

// Sagas
function* getSiteSurveysSaga(action) {
  try {
    const { data } = yield call(fetchSiteSurveysApi, action?.payload)
    yield put(getSiteSurveysSuccess(data))
  } catch (error) {
    yield put(getSiteSurveysFail(error.response?.data || error.message))
  }
}

function* addSiteSurveySaga(action) {
  try {
    const { data } = yield call(addSiteSurveyApi, action.payload?.sitesurvey)
    yield put(addSiteSurveySuccess(data));
    const id = JSON.parse(Cookies.get('authUser'))?.userId;
    action.payload?.navigate(`/SiteSurveyDetails/${data?.Data?.[0]?.siteSurveyId}`);
    toast.success('Site Survey added successfully!');
    yield put(getSiteSurveys(id))
  } catch (error) {
    if (error.response?.status === 400 && error.response?.data?.fieldErrors) {
      yield put(setSiteSurveyFieldErrors(error.response.data.fieldErrors))
    } else {
      yield put(addSiteSurveyFail(error.response?.data || error.message))
    }
  }
}

function* updateSiteSurveySaga(action) {
  try {
    const { data } = yield call(updateSiteSurveyApi, action.payload)
    yield put(updateSiteSurveySuccess(data))
    const id = JSON.parse(Cookies.get('authUser'))?.userId
    toast.success('Site Survey updated successfully!')
    yield put(getSiteSurveys(id))
  } catch (error) {
    if (error.response?.status === 400 && error.response?.data?.fieldErrors) {
      yield put(setSiteSurveyFieldErrors(error.response.data.fieldErrors))
    } else {
      yield put(updateSiteSurveyFail(error.response?.data || error.message))
    }
  }
}

function* deleteSiteSurveySaga(action) {
  try {
    yield call(deleteSiteSurveyApi, action.payload)
    yield put(deleteSiteSurveySuccess(action.payload))
    const id = JSON.parse(Cookies.get('authUser'))?.userId
    toast.success('Site Survey deleted successfully!')
    yield put(getSiteSurveys(id))
  } catch (error) {
    yield put(deleteSiteSurveyFail(error.response?.data || error.message))
  }
}

// Watcher saga
function* SiteSurveySaga() {
  yield takeEvery(GET_SITESURVEYS, getSiteSurveysSaga)
  yield takeEvery(ADD_SITESURVEY, addSiteSurveySaga)
  yield takeEvery(UPDATE_SITESURVEY, updateSiteSurveySaga)
  yield takeEvery(DELETE_SITESURVEY, deleteSiteSurveySaga)
}

export default SiteSurveySaga
